export function numericSortCodes(a: any, b: any) {
    if (a.hasOwnProperty('Code')) {
        return a.Code.localeCompare(b.Code, undefined, { numeric: true, sensitivity: 'base' });
    }
    return false;
}
